<template>
  <div v-show="icons.length > 1">
    <div
      v-for="(icon, index) in icons"
      :key="icon"
      class="mr-2 grid cursor-pointer place-content-center rounded-xl px-4 py-2.5 transition duration-300 last:mr-0 hover:opacity-80"
      :class="[activeTile === index ? 'bg-collection' : 'shadow-drop-2']"
      @click="emit('change-group', index)"
    >
      <SvgIcon
        :name="`teacher/${icon}`"
        class="size-4"
        :class="[activeTile === index ? 'text-white-100' : 'text-[#ababab]']"
      />
    </div>
  </div>
</template>

<script setup>
defineProps({
  icons: {
    type: Array,
    default: () => [],
  },
  activeTile: {
    type: Number,
    default: 0,
  },
});

const emit = defineEmits(['change-group']);
</script>
